import { Tooltip } from '@lib/components'

import css from '../../styles.module.css'

type CollaborationViewersRestProps = {
  count: number
}

export const CollaborationViewersRest = ({
  count,
}: CollaborationViewersRestProps) => {
  if (count <= 0) {
    return null
  }

  const countText = `+${count} user${count > 1 ? 's' : ''}`

  return (
    <Tooltip content={countText} position="bottom" spacing="md">
      <div className={css.rest}>
        <span>+{count}</span>
      </div>
    </Tooltip>
  )
}
